import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

const KbdMap = {
  ctrl: '⌃',
  control: '⌃',

  meta: '⌘',
  cmd: '⌘',
  command: '⌘',

  shift: '⇧',

  alt: '⌥',
  option: '⌥',

  enter: '↵',
  return: '↵',

  space: '␣',
  spacebar: '␣',

  backspace: '⌫',
  delete: '⌫',

  esc: 'esc',
  escape: 'esc',
} as const;

export interface KbdProps {
  keys: (keyof typeof KbdMap | string)[];
  inline?: boolean;
}

export function Kbd({ keys, inline }: KbdProps) {
  return (
    <kbd className={cn(css.kbd, inline && css.inline)}>
      {keys.map((key) => {
        const char = key in KbdMap ? KbdMap[key as keyof typeof KbdMap] : key;
        const isSymbol = /[^\w\s]/.test(char);
        const isEnter = key === 'return' || key === 'enter';
        return (
          <span
            key={key}
            className={cn(
              css.char,
              isSymbol && css.symbol,
              isEnter && css.enter
            )}
          >
            {char}
          </span>
        );
      })}
    </kbd>
  );
}
